import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang('esmx'); // Idioma por defecto
  }

  ngOnInit(): void {
  }

}
